import React from 'react';
import Fab from '@material-ui/core/Fab';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Grid } from '@material-ui/core';
import axios from 'axios';
import userService from '../../user.service';
import { toast } from 'react-toastify';
import { find, isEmpty } from 'lodash';
import useStore from '../../Store/Store';
import Button from '../../components/Button';

const useStyles = makeStyles((theme) => ({
  fab: {
    position: 'fixed',
    bottom: theme.spacing(7),
    right: theme.spacing(7),
    zIndex: '10000',
  },
}));

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '10px',
};

const EmergencyButton = () => {
  const user = useStore((state) => state.user);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [emergencySubscription, setEmergencySubscription] = React.useState(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  React.useEffect(() => {
    if (!isEmpty(user)) {
      const data = find(user?.stripeInfo?.subscriptions, (i) => i.type === 'EMERGENCY');
      setEmergencySubscription(data);
    }
  }, [user]);

  const handleClickEmergency = async () => {
    setLoader(true);
    try {
      const userId = user?._id || user?.id;
      await axios.post(
        process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/emergencyAlarm`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: localStorage.getItem('auth'),
          },
        },
      );
      toast.success('Emergency Alert Sent!');
      handleClose();
    } catch (error) {
      console.log('emergency error==>', error);
      toast.error('Something went wrong!');
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      {!isEmpty(emergencySubscription) && (
        <>
          <Fab color="secondary" size="large" className={classes.fab} onClick={handleOpen}>
            SOS
          </Fab>

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Are you sure you want to trigger the emergency alert?
              </Typography>
              <Grid style={{ justifyContent: 'end', display: 'flex', marginTop: '20px' }}>
                <Button text="Yes" style={{ marginRight: '10px' }} onClick={handleClickEmergency} loading={loader} />
                <Button text="Cancel" onClick={handleClose} bg="light" />
              </Grid>
            </Box>
          </Modal>
        </>
      )}
    </>
  );
};

export default EmergencyButton;
